import "./BiomarkerReportConfigurationViewComponent.scss";
import ButtonComponent from "../../../../../shared/components/core/button/ButtonComponent";
import EditIcon from "@mui/icons-material/Edit";
import React from "react";
import {Grid} from "@mui/material";
import DetailsDataKeyValueComponent
    from "../../../../../shared/components/details-data-key-value-component/detailsDataKeyValueComponent";
import commonService from "../../../../../shared/services/common.service";
interface BiomarkerReportConfigurationViewComponentProps {
    canEdit?: boolean;
    onEditModeOpen: () => void;
    biomarkerReportConfiguration?: any;
    reportFormat?: any;
}

const BiomarkerReportConfigurationViewComponent = (props: BiomarkerReportConfigurationViewComponentProps) => {
    const {onEditModeOpen, canEdit, biomarkerReportConfiguration} = props;

    return (
        <div className={'biomarker-report-configuration-view-component'}>
            <div className={'biomarker-report-configuration-view-title-and-action-wrapper'}>
                <div className={'biomarker-report-configuration-view-title'}>Report Configuration</div>
                <div className={'biomarker-report-configuration-view-action-wrapper'}>
                    {canEdit && <div className={'edit-action-button'}>
                        <ButtonComponent
                            className={"white-space-nowrap"}
                            type="button"
                            color={"primary"}
                            variant={"outlined"}
                            startIcon={<EditIcon/>}
                            fullWidth={true}
                            handleClick={onEditModeOpen}
                        >
                            Edit Details
                        </ButtonComponent>
                    </div>
                    }
                </div>
            </div>
            <div>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={12}
                          md={6}
                          xl={6}>
                        <DetailsDataKeyValueComponent
                            title={"Gender"}> {biomarkerReportConfiguration?.gender ? commonService.capitalizeFirstLetterOfEachWord(biomarkerReportConfiguration?.gender) : 'N/A'} </DetailsDataKeyValueComponent>
                    </Grid>
                    <Grid item xs={12} sm={12}
                          md={6}
                          xl={6}>
                        <DetailsDataKeyValueComponent
                            title={"Age"}> {biomarkerReportConfiguration?.age || 'N/A'} </DetailsDataKeyValueComponent>
                    </Grid>
                </Grid>
                <Grid container spacing={2}>

                    {
                        biomarkerReportConfiguration?.rules.map((rule: any, index: number) => {
                            return (
                                <Grid item xs={12} sm={12}
                                      md={6}
                                      xl={6}>
                                    <DetailsDataKeyValueComponent
                                        title={"Result " + (index + 1)}> {commonService.generateRuleFromRuleObject(rule) || 'N/A'} </DetailsDataKeyValueComponent>
                                </Grid>
                            );
                        })
                    }
                </Grid>
                {
                    biomarkerReportConfiguration?.reportFormat === "Qualitative" && <DetailsDataKeyValueComponent
                        title={"Expected Result"}> {biomarkerReportConfiguration?.expectedResults || 'N/A'} </DetailsDataKeyValueComponent>
                }
                <DetailsDataKeyValueComponent
                    title={"Biomarker Note"}> {biomarkerReportConfiguration?.biomarkerNotes || 'N/A'} </DetailsDataKeyValueComponent>

            </div>
        </div>
    );

};

export default BiomarkerReportConfigurationViewComponent;